import React, { memo, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownItem, Button } from "reactstrap";

import { getMessage } from "CONFIG/i18n";
import { CONFIG } from 'UTILS/Constants';

import expand_button from "ASSETS/Images/expand-button16.webp";

import style from './style.module.less';

const Container = () => {

  const [isOpen, setIsOpen] = useState(false);

  const toggleIsOpen = useCallback(() => {
    setIsOpen((state) => !state);
  }, []);

  const history = useHistory();

  const gotoSupportCenter = useCallback(() => {
    history.push(CONFIG.path.supportCenter)
  }, [history]);

  const goToSupportCenterReport = useCallback(() => {
    history.push(CONFIG.path.supportCenterReport)
  }, [history]);

  return  (
    <div>
      <Button 
        className="customBtn whiteOnClick ripple addUserButton"
        onClick = {gotoSupportCenter}
      > 
        {getMessage("SUPPORT_CENTER")}
      </Button>
      <Button 
        className="mergedCustomBtn whiteOnClick ripple"
        onClick = {toggleIsOpen}
      > 
        <img src={expand_button} className="button"/>
      </Button>
      <Dropdown
        direction="down"
        isOpen={isOpen}
        toggle={toggleIsOpen}
      >
        <DropdownMenu className={`${style.menu} p-0`}>
          <DropdownItem
            className={style.item}
            onClick={gotoSupportCenter}>
            <span className={style.itemContent}>
              {getMessage("SUPPORT_CENTER")}
            </span>
          </DropdownItem>
          <DropdownItem divider className="m-0"/>
          <DropdownItem
            className={style.item}
            onClick={goToSupportCenterReport}>
            <span className={style.itemContent}>
              {getMessage("REPORT_OUTPUT")}
            </span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}

/**
 * MEMO
 * The parent component is mounted an unusual number of times and should be memoized.
 */
export const LinkListButton = memo(Container);